import {Text} from '../Text/Text';
import {ToastProps} from './ToastProps.interface';

export function Toast({message}: ToastProps) {
  return (
    <div className="mx-15pxr w-fit-content max-w-360pxr rounded-3pxr bg-static-mono-90 py-16pxr px-26pxr">
      <Text className="font-small1 inline-block whitespace-pre-wrap break-all text-center text-static-mono-10">
        {message}
      </Text>
    </div>
  );
}
